import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';
import SectionLabel from '../common/SectionLabel';

const AboutHero = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="relative max-w-4xl mx-auto text-center"
    >
      <div className="mb-8 flex justify-center">
        <SectionLabel>About</SectionLabel>
      </div>
      <h2 className="mb-8 text-4xl text-white md:text-5xl">
        About ThirtyFive Studio
      </h2>

      {/* Description with enhanced typography */}
      <p className={cn(
        "text-xl text-white/90 leading-relaxed",
        "mb-8 font-light tracking-wide"
      )}>
        At ThirtyFive Studio, we provide a full spectrum of digital solutions designed to help 
        businesses succeed in the modern online landscape. Our expertise spans website design 
        and development, app creation, branding, and digital transformation, ensuring your 
        business has everything it needs to thrive in the USA market and beyond.
      </p>

      {/* Location badge */}
      <div className={cn(
        "inline-flex items-center px-6 py-3",
        "bg-primary-500/10 backdrop-blur-sm",
        "border border-primary-500/20",
        "rounded-full"
      )}>
        <span className="text-lg text-primary-300 font-medium">
          Proudly serving clients nationwide and abroad
        </span>
      </div>
    </motion.div>
  );
};

export default AboutHero;
